<template>
  <transition name="el-fade-in-linear">
    <div @click.stop class="add-ins-dialog-component" v-show="showModal">
      <hi-dialog
        class="dialog"
        :title="title"
        @close="close"
        v-show="!hideLogin"
        :hideClose="hideClose"
      >
        <div class="form-container">
          <div class="message" v-if="message">{{ message }}</div>
          <div class="form-item-container">
            <input
              v-model="form.username"
              autocomplete="off"
              :placeholder="usernamePlaceholder"
            />
          </div>
          <div class="form-item-container">
            <input
              v-model="form.password"
              type="password"
              autocomplete="new-password"
              :placeholder="passwordPlaceholder"
            />
          </div>
          <div class="secure-container">
            <div class="icon"></div>
            <div class="text">Secure Login</div>
          </div>
          <div class="login-btn" @click="loginClick">Login</div>
          <div class="login-des" v-if="type !== 'login'">
            Please make sure to log in with Instagram username(NOT email
            address)
          </div>
        </div>
      </hi-dialog>
      <rich-modal
        v-model="showVerify"
        :title="$t('verifyModal.title')"
        :buttonText="$t('verifyModal.sendCode')"
        @btn-click="verifyClick"
        @close="showVerify = false"
      >
        <div class="modal-des">{{ $t("verifyModal.loginContent") }}</div>
        <radio
          class="modal-radio"
          v-model="verify.typeIndex"
          :options="verify.types"
        ></radio>
      </rich-modal>
      <rich-modal
        v-model="showSendCode"
        @close="closeCode"
        @back="CodeBack"
        :show-back-btn="true"
        :title="$t('verifyModal.title')"
        :buttonText="$t('verifyModal.sendBtn')"
        @btn-click="sendClick"
      >
        <div class="modal-des" v-html="verificationNote"></div>
        <div class="modal-code-input-container">
          <div v-show="verify.sendError" class="modal-error-msg">
            {{ verify.sendError }}
          </div>
          <code-input class="code-input" v-model="verify.code"></code-input>
          <div class="reset-btn" @click="resetCode">
            {{ $t("verifyModal.notReceive") }}
            <span class="code-test">{{ $t("verifyModal.newCode") }}</span>
          </div>
          <!--  2019.5.15 验证码错误添加特殊提示-->
          <div
            class="fix-error-msg"
            v-if="verify.sendError && verify.errorCode === 3406"
          >
            How to fix wrong code? Open your Instagram App and verify this login
            activity. Then come back to Apphi and input code again
          </div>
        </div>
      </rich-modal>
    </div>
  </transition>
</template>

<style lang="less" scoped>
@import "../../../assets/style/theme.less";

.add-ins-dialog-component {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 500;

  .dialog {
    min-height: auto;
    max-height: inherit;
  }

  .form-container {
    padding: 30px 25px 55px 25px;
    width: 390px;
    overflow: auto;
    flex: 1;

    .form-item-container {
      height: 49px;
      background: #fafafa;
      border-radius: 2px;
      border: solid 1px #e5e5e5;
      line-height: 49px;
      width: 100%;
      margin-bottom: 10px;

      input {
        width: 100%;
        height: 100%;
        background: transparent;
        font-size: 14px;
        text-align: center;
        border: 0;
      }
    }

    .secure-container {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      .icon {
        background-image: url("../../../../public/images/common/secure_login_icon.png");
        height: 15px;
        width: 13px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }

      .text {
        color: #7ed321;
        font-size: 14px;
        margin-left: 10px;
        position: relative;
        top: 1px;
      }
    }

    .message {
      font-size: 15px;
      color: red;
      text-align: center;
      position: relative;
      bottom: 16px;
      font-weight: 500;
    }

    .login-btn {
      display: flex;
      background-color: #e72954;
      border-radius: 6px;
      align-items: center;
      justify-content: center;
      height: 49px;
      color: white;
      font-size: 16px;
      margin-top: 40px;
      cursor: pointer;

      &:hover,
      &:active {
        opacity: 0.8;
      }
    }

    .login-des {
      font-size: 14px;
      color: @font-color-gray;
      text-align: center;
      margin-top: 15px;
    }
  }

  .modal-des {
    margin: 15px 0;
    font-size: 14px;
  }

  .modal-radio {
    margin-top: 20px;
    margin-bottom: 30px;
    cursor: pointer;
  }

  .modal-code-input-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .modal-error-msg {
      font-size: 14px;
      color: #e10040;
    }

    .code-input {
      margin-bottom: 43px;
      margin-top: 25px;
    }

    .code-input {
      margin-bottom: 10px;
      margin-top: 25px;
    }

    .reset-btn {
      color: @font-color-gray;
      font-size: 13px;
      margin-top: 30px;
      margin-bottom: 12px;
      cursor: pointer;

      .code-test {
        color: #e10040;
      }
    }

    .fix-error-msg {
      color: #e10040;
      font-size: 13px;
      margin-bottom: 25px;
      text-align: center;
    }
  }
}
</style>
<script>
import hiDialog from "../../common/dialog/Index.vue";
import RichModal from "../../plan_header/send_code/RichModal";
import Radio from "../../plan_header/send_code/Radio";
import CodeInput from "../../plan_header/send_code/CodeInput";
import { checkpoint as checkpointRes } from "../../../api/publisher";
import { showErrorMsg, initValidate } from "../../../utils/errors";
import {
  createPubliships,
  createPublishipsByCode,
} from "../../../service/user";
import { CURRENT_PUBLISHER_ID } from "../../../store/mutation-types";
import { LinkInstagram } from "../../../service/model/user";

export default {
  name: "AddInsDialogComponent",
  components: { hiDialog, RichModal, Radio, CodeInput },
  model: {
    prop: "show",
    event: "updateShow",
  },
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
      afterClose: () => {}, // 关闭回调
      autoSwitch: false,
      message: "", // 登录按钮上方提示信息
      insType: "add", // 表单类型 add 添加ins账号 verify 需要验证密码用户
      verify: {
        types: [], // 用户可以选择发送的类型
        typeIndex: 0, // 选中类型索引
        sendError: "", // 发送时候弹出提示
        errorCode: 0, // 2019.5.15 验证码错误添加特殊提示
        timestamp: 0, // 验证码弹出的时间戳，60秒可以再次发送验证码，到时候会刷新时间
        code: "", // 用户输入code
      },
      sendForm: {},
      showVerify: false,
      showSendCode: false,
      showModal: this.show,
      hideLogin: false,
    };
  },
  computed: {
    verificationNote() {
      const text = this.$t("verifyModal.verificationNote", {
        type: `<span style="font-weight: 600">${this.sendCodeName}</span>`,
      });
      return text;
    },
    /**
     * 计算发送code时加粗文案
     */
    sendCodeName() {
      if (this.sendForm) {
        if (this.sendForm.method === 0) {
          return this.sendForm.phone;
        } else {
          return this.sendForm.email;
        }
      } else {
        return "";
      }
    },
    hideClose() {
      return this.type === "login";
    },
    title() {
      if (this.type === "login") {
        return "Apphi Login";
      } else {
        if (this.insType === "add") {
          return "Add Social Account";
        } else if (this.insType === "verify") {
          return "Login Instagram";
        }
      }
    },
    usernamePlaceholder() {
      if (this.type === "login") {
        return "email";
      } else {
        return "Instagram username";
      }
    },
    passwordPlaceholder() {
      if (this.type === "login") {
        return "password";
      } else {
        return "Instagram password";
      }
    },
  },
  methods: {
    close() {
      this.showModal = false;
      this.afterClose();
    },
    /**
     * 绑定publisher
     * @returns {Promise<void>}
     */
    async linkedPublisher() {
      const publisher = await createPubliships(this.form);
      return publisher;
    },
    /**
     * 登录按钮点击事件
     * @returns {Promise<void>}
     */
    async loginClick() {
      if (this.type === "login") {
        this.$emit("login-click", this.form);
      } else {
        // 清空错误信息
        this.verify.sendError = "";
        this.verify.code = "";
        const loading = this.$loading();
        try {
          if (!this.form.password) {
            throw initValidate({ msg: "Please input your Instagram username" });
          }
          if (!this.form.username) {
            throw initValidate({ msg: "The username was invalid" });
          }
          const publisher = await this.linkedPublisher();
          this.$toast.show({ message: this.$t("common.success") });
          this.showModal = false;
          // 登录之后切换到新登录用户
          const link = new LinkInstagram(publisher);
          if (this.autoSwitch) {
            this.$store.commit(CURRENT_PUBLISHER_ID, link.publisherId);
          }
        } catch (e) {
          if (e.errorCode === 11450) {
            loading.close();
            await this.$confirm.show({
              text: e.msg,
              yesText: "Help",
            });
            const email = this.user.email;
            window.open(
              `https://mapiz.wufoo.com/forms/apphi-help/def/field3=${email}&field17=${this.form.username}`,
              "_blank"
            );
            return;
          }
          // 当3403 和 3405说明是is was me
          if (e.errorCode === 3403) {
            this.sendForm = e.responseData.data;
            this.verify.sendError = "";
            if (this.sendForm) {
              // 弹出选择页面
              if (this.sendForm.next === "validation_method_choice") {
                this.resetValidateType();
                // 显示让用户选择页面
                this.showVerify = true;
              } else if (this.sendForm.next === "enter_validation_code") {
                // 显示让用户输入页面
                this.showSendCode = true;
                this.verify.timestamp = new Date().getTime();
                // 清空原来输入项和错误
                this.verify.code = "";
                this.verify.sendError = "";
              }
            } else {
              console.error("发现是is me 模式但是 data为空");
            }
            // this.showVerifyModal = true
          } else {
            showErrorMsg(e);
          }
        } finally {
          loading.close();
        }
      }
    },
    /**
     * 因多个地方调用checkpoint 所以统一封装
     */
    async checkpoint({ action }) {
      const loading = this.$loading();
      try {
        const form = {
          ...this.sendForm,
          action,
        };
        // 提交用户选中类型
        const { data } = await checkpointRes({ form });
        // 拼接发送表单
        this.sendForm.code = data.code;
        return Promise.resolve();
      } catch (e) {
        const { response } = e;
        alert(response.message);
        return Promise.reject(response.message);
      } finally {
        loading.close();
      }
    },
    /**
     * 选择验证类型modal确认按钮点击
     */
    async verifyClick() {
      // 调取验证接口
      const loading = this.$loading();
      try {
        this.sendForm.method = this.verify.types[this.verify.typeIndex].type;
        await this.checkpoint({ action: "send" });
        // 成功后显示发送code
        this.showVerify = false;
        this.showSendCode = true;
        // 清空原来输入项和错误
        this.verify.code = "";
        this.verify.sendError = "";
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
      }
    },
    /**
     * 重置验证方式
     */
    resetValidateType() {
      this.verify.types = [];
      if (this.sendForm.phone) {
        this.verify.types.push({
          text: `Phone: ${this.sendForm.phone}`,
          type: 0,
        });
      }
      if (this.sendForm.email) {
        this.verify.types.push({
          text: `Email: ${this.sendForm.email}`,
          type: 1,
        });
      }
    },
    /**
     * 关闭发送code组件
     */
    async closeCode() {
      await this.checkpoint({ action: "reset" });
      this.showSendCode = false;
      this.verify.sendError = "";
    },
    /**
     * 重新发送验证码
     */
    async resetCode() {
      const currentTime = new Date().getTime();
      if (currentTime - this.verify.timestamp > 60000) {
        this.verify.timestamp = currentTime;
        await this.checkpoint({ action: "replay" });
      } else {
        await this.$alert.show({
          title: "Wait a Moment",
          text: "Instagram can only send you a new code every 60 seconds. Please request later.",
          yesText: "Ok",
        });
      }
    },
    async CodeBack() {
      await this.checkpoint({ action: "reset" });
      this.resetValidateType();
      this.showSendCode = false;
      this.showVerify = true;
      this.verify.sendError = "";
    },
    /**
     * 发送验证类型modal确认按钮点击
     */
    async sendClick() {
      // 先对输入结果进行验证
      if (!this.verify.code) {
        this.verify.sendError = "Cannot be empty.";
        return;
      }
      this.sendForm.code = this.verify.code;
      const loading = this.$loading();
      try {
        // 发送送code
        await createPublishipsByCode({
          ...this.form,
          code: this.verify.code,
          path: this.sendForm.api_path,
        });
        // 成功后显示发送code
        this.showSendCode = false;
        // 全部成功之后清空选项
        this.verify.types = [];
        this.verify.typeIndex = 0;
        this.verify.errorMsg = "";
        this.sendForm = {};
        this.showModal = false;
      } catch (e) {
        this.verify.sendError = e.msg;
        this.verify.errorCode = e.errorCode;
      } finally {
        loading.close();
      }
    },
    /**
     * 显示登录框
     * @param form 表单填写
     */
    setForm({
      username,
      insType = "add",
      message = "",
      afterClose = () => {},
      autoSwitch = true,
    }) {
      this.showModal = true;
      this.form.username = username;
      this.form.password = "";
      this.insType = insType;
      this.message = message;
      this.afterClose = afterClose;
      this.autoSwitch = autoSwitch;
    },
  },
  watch: {
    showModal(val) {
      this.$emit("updateShow", val);
      if (!val) {
        this.form.password = this.form.username = "";
      }
    },
    show(val) {
      this.showModal = val;
    },
    showVerify(val) {
      // 验证方式和发送code有一个显示则登录隐藏
      this.hideLogin = val || this.showSendCode;
    },
    showSendCode(val) {
      this.hideLogin = val || this.showVerify;
      // 验证方式和发送code有一个显示则登录隐藏
    },
  },
};
</script>
